import { useMutation } from '@tanstack/react-query';
import { updateLifeArea } from 'shared/services/backend-api';
import { LifeArea, LocalizedLifeArea } from 'shared/types/life-area';

export const useUpdateLifeAreaMutation = () =>
  useMutation({
    mutationFn: async (lifeArea: Partial<LifeArea | LocalizedLifeArea>) =>
      updateLifeArea(lifeArea),
  });
